import { createClient } from 'contentful';

const client = createClient({
    space: '7aohbjnve3qn',
    accessToken: 'KJIOJKZsB-6xze28H-HuiwcQHhUv2lngc5tjuDMn6LI',
  });
  
  export default client;

  export const fetchEntries = async () => {
    try {
      const entries = await client.getEntries();
      return entries.items;
    } catch (error) {
      console.error('Error fetching entries:', error);
    }
  };